import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  text: 'I used to repeat the same circuits every week because I had nothing else ready. Now I have six complete volumes at my fingertips and my sessions are completely different. My athletes notice it every single class.',
  author: 'Coach Michael R.',
  role: 'Functional Training Specialist',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=200&auto=format&fit=crop'
}, {
  text: "I had programming for some things but nothing organized or progressive. Functional & Cross Ready gave me a complete system I can actually rely on. It's the first time I feel truly prepared walking into every session.",
  author: 'Coach Sarah L.',
  role: 'CrossFit & Functional Coach',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=200&auto=format&fit=crop'
}, {
  text: 'The special populations volume alone was worth everything. I finally know how to train my senior clients and my postpartum athletes without second-guessing myself. This is the guide I needed two years ago.',
  author: 'Coach Daniel M.',
  role: 'Personal Trainer & Group Coach',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=200&auto=format&fit=crop'
}, {
  text: 'The bonuses are a goldmine on their own. The first-session scripts and the warm-up vault save me hours every single week. I look more professional in front of my clients and it shows in my retention.',
  author: 'Coach Jessica T.',
  role: 'Functional Fitness Coach',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=200&auto=format&fit=crop'
}, {
  text: 'I finally stopped improvising. The periodization models in Volume 6 completely changed how I structure my training blocks. My competitive athletes are hitting PRs they never reached before.',
  author: 'Coach Marcus B.',
  role: 'Strength & Conditioning Coach',
  avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?q=80&w=200&auto=format&fit=crop'
}, {
  text: 'As a newer coach this gave me the confidence I was missing. Everything is organized, progressive and ready to use. It feels like having a senior mentor in my pocket every day.',
  author: 'Coach Andrea P.',
  role: 'Group Training Instructor',
  avatar: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?q=80&w=200&auto=format&fit=crop'
}];
export function Testimonials() {
  return <section className="py-12 md:py-24 px-4 bg-brand-dark relative overflow-hidden" data-id="element-168">
      <div className="max-w-6xl mx-auto" data-id="element-169">
        <div className="text-center mb-10 md:mb-16" data-id="element-170">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-171">
            WHAT COACHES ARE{' '}
            <span className="text-brand-blue" data-id="element-172">ALREADY SAYING</span>
          </h2>
          <div className="flex items-center justify-center gap-1 text-brand-orange" data-id="element-173">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 md:w-6 md:h-6 fill-current" data-id="element-174" />)}
          </div>
          <p className="mt-3 md:mt-4 text-sm md:text-base text-zinc-400" data-id="element-175">
            4.9/5 — Trusted by coaches worldwide 🌍
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-176">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx % 3 * 0.1
        }} className="bg-zinc-900/50 p-6 md:p-7 rounded-2xl border border-zinc-800 relative flex flex-col" data-id="element-177">
              <Quote className="absolute top-4 right-4 w-8 h-8 md:w-10 md:h-10 text-zinc-800" data-id="element-178" />
              <div className="flex gap-1 text-brand-orange mb-4" data-id="element-179">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-current" data-id="element-180" />)}
              </div>
              <p className="text-zinc-300 text-sm md:text-base leading-relaxed mb-6 relative z-10 flex-grow" data-id="element-181">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-zinc-800" data-id="element-182">
                <img src={t.avatar} alt={t.author} className="w-11 h-11 rounded-full object-cover border-2 border-brand-blue/40 shrink-0" data-id="element-183" />
                <div data-id="element-184">
                  <p className="font-bold text-white font-oswald text-base md:text-lg tracking-wide leading-tight" data-id="element-185">
                    {t.author}
                  </p>
                  <p className="text-brand-blue text-xs font-medium" data-id="element-186">
                    {t.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}